<script setup lang="ts">
import { toRef } from 'vue'

import type { KanbanCommentTask } from '@entities/kanban-comment'

import { AppTextLink } from '@shared/ui/typography'

import { useKanbanCommentTaskMeta } from '../../model/comment/comment-task-meta.hook'

defineOptions({
  name: 'KanbanCommentTaskMeta',
})

const props = defineProps<{
  task: KanbanCommentTask
}>()

const {
  refRelatedToLabel,
  refRelatedToUrl,
  refTaskLabel,
  refTaskUrl,
} = useKanbanCommentTaskMeta({
  task: toRef(props, 'task'),
})
</script>

<template>
  <AppTextLink
    name="body2"
    color="blue-700"
    :href="refRelatedToUrl"
  >
    {{ refRelatedToLabel }}
  </AppTextLink>
  <AppTextLink
    name="body2"
    color="blue-700"
    :href="refTaskUrl"
  >
    {{ refTaskLabel }}
  </AppTextLink>
</template>
